// @flow
import type { DictionaryType } from "../types/GeneralTypes";

export const buttonStyles = (theme: DictionaryType): DictionaryType => ({
  darkBtn: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.light
    }
  },
  linkBtn: {
    color: theme.palette.primary.light,
    "&:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.third
    }
  },
  primaryBtn: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: "0.9375rem",
    border: "3px solid " + theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.third,
      color: theme.palette.primary.contrastText
    }
  },
  disabledBtn: {
    backgroundColor: theme.palette.grey.light,
    color: theme.palette.grey.main
  },
  lightBtn: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    border: "1px solid " + theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.third,
      color: theme.palette.primary.contrastText
    }
  }
});

export type ButtonStylesClassesType = {
  darkBtn: DictionaryType,
  linkBtn: DictionaryType,
  primaryBtn: DictionaryType,
  disabledBtn: DictionaryType,
  lightBtn: DictionaryType
};
